import { JsonObject } from 'json2typescript';
import { ChatTopicsAddResponseInterface } from '../interfaces/chat-topics-add-response.interface';

@JsonObject('ChatTopicsAddResponseModel')
export class ChatTopicsAddResponseModel
  implements ChatTopicsAddResponseInterface
{
  Id?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
